import React from 'react'
import { DataTable } from 'primereact/datatable'
import { SplitButton } from 'primereact/splitbutton';
import currencyFormater from 'currency-formatter'
import { Column } from 'primereact/column'

import * as XLSXStyle from 'xlsx-js-style';
import { saveAs } from 'file-saver';

import GeneralServices from '../../app/service/generalServices'
import TableFilters from '../../components/tableFilters'
import ConstantsUtil from '../../context/constantsUtil'
import { Button } from 'primereact/button'
import { classNames } from 'primereact/utils'
import DetalhamentoMovimentacaoProductDialog from '../../components/product/detalhamentoMovimentacaoProductDialog'
import EscolhaSituacaoNotasDialog from '../../components/product/escolhaSituacaoNotasDialog'
import AuthService from '../../app/service/authService'
import * as popUp from '../../components/toastr';
import TransactionService from '../../app/service/estoque/transactionService';
import HandleErrorService from '../../app/service/handleErrorService';
import CadastroProdutoService from '../../app/service/central/cadastroProdutoService';

const codigoLabel = 'Código'
const produtoLabel = 'Produto'
const ncmLabel = 'NCM'
const cfopLabel = 'CFOP'
const quantidadeLabel = 'Quantidade'
const valorTotalLabel = 'Valor Total'
const porcentagemLabel = '%'
const porcentagemAcumuladaLabel = 'Acumulado'
const fornecedorLabel = 'Fornecedor'
const colunaExportValorLabel = 'Valor'
const colunaExportDescricaoLabel = 'Descrição'
const colunaGrupoExportacaoLabel= 'Grupo'
const colunaSubGrupoPrefixoExportacaoLabel= 'Subgrupo '

const separadorGruposEstoque = " - "

class TransactionByProductTable extends React.Component {

    state = {
        filteredList: null,
        displayDetalhamentoDialog: false,
        productDetalhamento: null,
        displayEscolhaSituacaoNotasDialog: false,
        isUnificadoExportacaoIndividuais: false,
    }

    constructor(){
        super()
        this.dt = React.createRef()
        this.exportarExcelButtonRef = React.createRef()
        this.exportarPdfButtonRef = React.createRef()
        this.tableFilters = new TableFilters();
        this.generalServices = new GeneralServices();
        this.transactionService = new TransactionService()
        this.cadastroProdutoService = new CadastroProdutoService()

    }

    componentDidMount(){
        this.onFilterChange(this.props.list)
    }

    onFilterChange = async (currentList) => {
        await this.setState({filteredList: currentList})
        // await this.generalServices.sleep(100)
        let valorTotalHeader = this.getValorTotalHeader()
        // //console.log("valorTotalHeader: ", valorTotalHeader)

        let porcentagemAcumulada = 0

        currentList.forEach(item => {
            let porcentagemItem = item.valor*100/valorTotalHeader
            porcentagemAcumulada+=porcentagemItem
            
            item.porcentagem = porcentagemItem
            item.porcentagemAcumulada = porcentagemAcumulada

        })

        this.setState({filteredList: currentList})

    }

    formataPorcentagem = porcentagem => {
        return `${GeneralServices.formatTo2CasasDecimais(porcentagem)}%`
    }

    getList = () => {
        return this.state.filteredList ? this.state.filteredList : this.props.list;
    }

    getListToExport = (isPdf) => {

        let list = this.getList()
        // console.log("getListToExport: ", list)
        let maiorNivelTipoEstoque = Math.max(...list.map(item => item.product.tipoEstoque.descricao.split(separadorGruposEstoque).length))
        // console.log("listTamanho: ", maiorNivelTipoEstoque)
        // console.log("listTamanho maior: ", Math.max(...listTamanho))

        let exportList = list.map(item => {
            
            let tipoDeEstoqueGrupoList = item.product.tipoEstoque.descricao.split(separadorGruposEstoque)

            let obj = {
              [codigoLabel]: item.product.codigo,
              [produtoLabel]: item.product.descricao,
              ...(this.isBuscaNFsEntrada() ? { [fornecedorLabel]: item.product.nomeFornecedor } : {}),
              [ConstantsUtil.tipoDeProdutoLabel]: item.product?.tipoProduto?.descricao,
              [ConstantsUtil.tipoDeEstoqueLabel]: item.product?.tipoEstoque?.descricao,
              [ncmLabel]: item.product.ncm,
              [cfopLabel]: item.product.cfop,
              [quantidadeLabel]: `${item.quantidade} UN`,
            //   [valorTotalLabel]: currencyFormater.format(item.valor, {locale: 'pt-BR', code: false}),
              [valorTotalLabel]: isPdf ? currencyFormater.format(item.valor, {locale: 'pt-BR', code: false}) : parseFloat(item.valor),
              [porcentagemLabel]: this.formataPorcentagem(item.porcentagem),
              [porcentagemAcumuladaLabel]: this.formataPorcentagem(item.porcentagemAcumulada),
              [colunaGrupoExportacaoLabel]: tipoDeEstoqueGrupoList[0]
            }

            for(let i = 1; i < maiorNivelTipoEstoque; i++){
                Object.assign(obj, { [colunaSubGrupoPrefixoExportacaoLabel + i]: tipoDeEstoqueGrupoList[i]});
            }

            return obj
          })

        exportList.push({
            [codigoLabel]: '',
            [produtoLabel]: '',
            [quantidadeLabel]: '',
            [valorTotalLabel]: ''
        })

        exportList.push({
            [codigoLabel]: 'Total',
            [produtoLabel]: `${this.getList().length} Itens`,
            [quantidadeLabel]: `${this.getQuantidadeTotal()} UN`,
            [valorTotalLabel]: currencyFormater.format(this.getValorTotal(), {locale: 'pt-BR', code: false})
        })

        // console.log("exportList final: ", exportList)
        return exportList
    }

    getListIndividualToExport = (list, isPdf, isUnificado) => {


        let exportList = list.map(item => {
            let obj = {
                [ConstantsUtil.filtroDataEmissaoLabelTratada]: GeneralServices.isoDateToBrDateWithHour(new Date(item.dhEmi)),
                [ConstantsUtil.filtroDataEntradaLabelTratada]: GeneralServices.isoDateToBrDateWithHour(new Date(item.dataHoraEntrada)),
                [ConstantsUtil.codigoProdutoLabel]: item.codigoProduto,
                [ConstantsUtil.nomeProdutoLabel]: item.nomeProduto,
                [ConstantsUtil.fornecedorLabel]: item.nomeFornecedor,
                [ConstantsUtil.tipoDeProdutoLabel]: item?.tipoProduto?.descricao,
                [ConstantsUtil.classificacaoDRELabel]: item?.classificacaoDRE,
                [ConstantsUtil.tipoDeEstoqueLabel]: item?.tipoEstoque?.descricao,
                [ConstantsUtil.fornecedorLabel]: item.nomeFornecedor,
                [ConstantsUtil.unidadeComercializadaLabel]: item.unidadeComercializada,
                [ConstantsUtil.numeroNFLabel]: item.numeroNF,
                [ConstantsUtil.situacaoNFLabel]: item.situacaoNF,
                [ConstantsUtil.valorTotalNFLabel]: isPdf ? currencyFormater.format(item.valorTotalNF, {locale: 'pt-BR', code: false}) : parseFloat(item.valorTotalNF),
                [ConstantsUtil.valorTotalProdutoNaNFLabel]: isPdf ? currencyFormater.format(item.valorTotalProduto, {locale: 'pt-BR', code: false}) : parseFloat(item.valorTotalProduto),
                [ConstantsUtil.quantidadeProdutoNaNFLabel]: item.quantidadeProduto,
                [ConstantsUtil.valorUnitarioProdutoLabel]: isPdf ? currencyFormater.format(item.valorUnitarioProduto, {locale: 'pt-BR', code: false}) : parseFloat(item.valorUnitarioProduto),
                [ConstantsUtil.conversaoLabel]: item.conversao,
                [ConstantsUtil.qtdConvertidaEmEstoqueLabel]: item.quantidadeConvertidaEmEstoque,
                [ConstantsUtil.valorProdutoUnitarioEmEstoqueLabel]: item.valorUnitarioProdutoEstoque,

            }

            if(isUnificado){
                let finalObj = {
                    [ConstantsUtil.empresaLabel]: item.nomeEmpresa
                }
                Object.assign(finalObj, obj)
                return finalObj
            }

            return obj

          })


        // console.log("exportList final: ", exportList)
        return exportList
    }

    getQuantidadeTotal = () => {
        let list = this.getList()
        let quantidadeTotal = 0
        list.forEach(item => quantidadeTotal += item.quantidade)
        return GeneralServices.formatTo2CasasDecimais(quantidadeTotal)
    }

    getValorTotal = () => {
        let list = this.getList()
        let valorTotal = 0
        list.forEach(item => valorTotal += item.valor ? item.valor : 0)
        return GeneralServices.formatTo2CasasDecimais(valorTotal)
    }

    getFilenameToExport = (porGrupo,isUnificado) => {
        const inicioNomeArquivo = this.isBuscaNFsEntrada() ? 'Compras' : 'Vendas'
        let porGrupoLabel = porGrupo ? "_Por_Grupos" : ""
        let nomeEmpresa = isUnificado ? "Unificado" : AuthService.getEmpresa()
        return `${inicioNomeArquivo}_de_${this.props.initialDate}_a_${this.props.finalDate}${porGrupoLabel}_${nomeEmpresa}`
    }

    exportXLSX = () => {
        // //console.log("this.exportarExcelButtonRef.current: ", this.exportarExcelButtonRef.current)
        this.exportarExcelButtonRef.current.show()
    }    

    exportXLSXPadrao = () => {
        // //console.log("initialDate: ", this.props.initialDate)
        
        AuthService.startBlockUi()

        let exportList = this.getListToExport(false)
        GeneralServices.exportExcel(exportList, "Vendas", this.getFilenameToExport(), [valorTotalLabel])

        AuthService.stopBlockUi()

    }

    getMapsExportacao = () => {
        let list = this.getList()
        let mapProdutosPorGrupo = this.mapProdutosPorGrupo(list)
        let mapGrupos = this.montaMapGrupos(list, separadorGruposEstoque)
        mapGrupos = this.preencheValoresGrupos(list, separadorGruposEstoque, mapGrupos)
        return {mapGrupos, separadorGruposEstoque, mapProdutosPorGrupo}
    }

    exportXLSXPorGrupos = () => {

        AuthService.startBlockUi()

        // let list = this.getList()
        // let separadorGruposEstoque = " - "
        // let mapProdutosPorGrupo = this.mapProdutosPorGrupo(list)
        // let mapGrupos = this.montaMapGrupos(list, separadorGruposEstoque)
        // mapGrupos = this.preencheValoresGrupos(list, separadorGruposEstoque, mapGrupos)

        const {listFinal, listFinalToExport} = this.getListFinalToExportPorGrupos()
        //console.log("listFinalToExport: ", listFinalToExport)
        // GeneralServices.exportExcel(listFinalToExport, "Vendas", this.getFilenameToExport())

        this.generateXLSXFileRelatorioProdutosPorGrupo(listFinalToExport, listFinal)

        AuthService.stopBlockUi()

    }

    getLancamentosIndividuais = (isUnificado, descricaoProdutosFiltradosList, situacao) => {

        const body = {
            descricaoProdutos: descricaoProdutosFiltradosList,
            tipoFiltro: 'DESCRICAO',
            situacao: situacao,
        }

        if(isUnificado){
            return this.cadastroProdutoService.getLancamentosProdutosIndividuaisUnificado(
                this.props.initialDate, this.props.finalDate, body
            )
        }

        return this.transactionService.getLancamentosIndividuais(this.props.initialDate, this.props.finalDate, body)
    }

    // antes de exportar, pergunta se o usuário quer todas as notas ou só as validadas
    abrirEscolhaSituacaoNotasIndividuais = (isUnificado) => {

        if(this.props.tipo !== ConstantsUtil.entradaLabel){
            popUp.infoPopUp("Funcionalidade disponível apenas para produtos comprados.")
            return;
        }

        this.setState({
            displayEscolhaSituacaoNotasDialog: true,
            isUnificadoExportacaoIndividuais: isUnificado,
        })
    }

    hideEscolhaSituacaoNotasDialog = () => {
        this.setState({displayEscolhaSituacaoNotasDialog: false})
    }

    onEscolherSituacaoNotasIndividuais = (situacaoEscolhida) => {
        const isUnificado = this.state.isUnificadoExportacaoIndividuais
        this.hideEscolhaSituacaoNotasDialog()
        this.exportXLSXIndividuais(isUnificado, situacaoEscolhida)
    }

    exportXLSXIndividuais = (isUnificado, situacao) => {

        // se o usuário não filtrou nada na tabela, manda a lista nula (backend traz todos os produtos)
        let descricaoProdutosFiltradosList = null
        if(this.estaFiltrando()){
            let filteredList = this.getList();
            descricaoProdutosFiltradosList = filteredList.map(item => item.product.descricao)
        }
        // console.log("codigoProdutosFiltradosList: ", descricaoProdutosFiltradosList)

        AuthService.startBlockUi()

        this.getLancamentosIndividuais(isUnificado, descricaoProdutosFiltradosList, situacao)
        .then(response => {
            let exportList = this.getListIndividualToExport(response.data.transactionIndividualList, false, isUnificado)
            GeneralServices.exportExcel(exportList, "Compras", this.getFilenameToExport(false, isUnificado), [valorTotalLabel])
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            AuthService.stopBlockUi()
        })

    }

    exportPDFIndividuais = () => {

        popUp.infoPopUp("Funcionalidade ainda não disponível.")

        // if(this.props.tipo !== ConstantsUtil.entradaLabel){
        //     popUp.infoPopUp("Funcionalidade disponível apenas para produtos comprados.")
        //     return;
        // }

        // AuthService.startBlockUi()

        // let columns = [
        //     { field: ConstantsUtil.filtroDataEmissaoLabelTratada, header: ConstantsUtil.filtroDataEmissaoLabelTratada },
        //     { field: ConstantsUtil.nomeProdutoLabel, header: ConstantsUtil.nomeProdutoLabel },
        //     { field: ConstantsUtil.fornecedorLabel, header: ConstantsUtil.fornecedorLabel },
        //     { field: ConstantsUtil.unidadeComercializadaLabel, header: ConstantsUtil.unidadeComercializadaLabel },
        //     { field: ConstantsUtil.numeroNFLabel, header: ConstantsUtil.numeroNFLabel },
        //     { field: ConstantsUtil.valorUnitarioProdutoLabel, header: ConstantsUtil.valorUnitarioProdutoLabel },
        //     { field: ConstantsUtil.quantidadeProdutoNaNFLabel, header: ConstantsUtil.quantidadeProdutoNaNFLabel },
        //     { field: ConstantsUtil.valorTotalProdutoNaNFLabel, header: ConstantsUtil.valorTotalProdutoNaNFLabel },
        //     { field: ConstantsUtil.valorTotalNFLabel, header: ConstantsUtil.valorTotalNFLabel },
        // ]

        // let exportColumns = columns.map(col => ({ title: col.header, dataKey: col.field }))

        // this.transactionService.getLancamentosIndividuais(this.props.initialDate, this.props.finalDate)
        // .then(response => {
        //     let exportList = this.getListIndividualToExport(response.data.transactionIndividualList, false)
        //     // GeneralServices.exportExcel(exportList, "Compras", this.getFilenameToExport(), [valorTotalLabel])
        //     this.createPDFFIle(this.getFilenameToExport(), exportColumns, exportList, exportList, false)
        // })
        // .catch(error => {
        //     HandleErrorService.handleError(error)
        // })
        // .finally(() => {
        //     AuthService.stopBlockUi()
        // })        
        

        // let exportList = this.getListIndividualToExport(true)
        // this.createPDFFIle(this.getFilenameToExport(), exportColumns, exportList, exportList, false)

    }    

    getListFinalToExportPorGrupos = () => {
        
        const {mapGrupos, separadorGruposEstoque, mapProdutosPorGrupo} = this.getMapsExportacao()
        
        let listFinal = []

        this.imprimeArvore("", 0, mapGrupos, separadorGruposEstoque, listFinal, mapProdutosPorGrupo)
        //console.log("listFinal: ", listFinal)

        let listFinalToExport = listFinal.map(item => {
            let prefixo = ""
            if(!item.analitico){
                if(item.nivel === 0){
                    prefixo = "Grupo"
                }
                else{
                    prefixo = `Subgrupo Nível ${item.nivel}`
                }
                prefixo += ": "
            }
            return {
                [colunaExportDescricaoLabel]: `${'    '.repeat(item.nivel)}${prefixo}${item.item}`,
                [colunaExportValorLabel]: parseFloat(item.valor),
            }
        })
        return {listFinal, listFinalToExport}
    }

    generateXLSXFileRelatorioProdutosPorGrupo = (listFinalToExport, listFinal) => {
        let worksheet = XLSXStyle.utils.json_to_sheet(listFinalToExport);
        const sheetName = 'Planilha';

        const headers = Object.keys(listFinalToExport[0]);
        const totalCols = headers.length;

        // // índices das colunas que queremos estilizar no cabeçalho
        // const descricaoColIndex = headers.findIndex(h => h === colunaExportDescricaoLabel);
        const valorColIndex = headers.findIndex(h => h === colunaExportValorLabel);

        // // Estilo do cabeçalho: negrito + texto centralizado
        // [descricaoColIndex, valorColIndex].forEach(colIndex => {
        //     const cellAddress = XLSXStyle.utils.encode_cell({ r: 0, c: colIndex }); // linha 1 = r:0
        //     if (worksheet[cellAddress]) {
        //         worksheet[cellAddress].s = {
        //             font: { bold: true },
        //             alignment: { horizontal: "center", vertical: "center" }
        //         };
        //     }
        // });

        // Garante que há um range definido
        const range = XLSXStyle.utils.decode_range(worksheet['!ref']);

        // Itera todas as colunas do range na primeira linha (r = 0)
        for (let c = range.s.c; c <= range.e.c; c++) {
            const cellAddress = XLSXStyle.utils.encode_cell({ r: 0, c });
            const cell = worksheet[cellAddress];
            if (!cell) continue; // se não existe célula nessa coluna da linha 0, segue

            // Mescla com estilo existente (se houver) para não perder outros atributos
            const prevStyle = cell.s || {};
            cell.s = {
                ...prevStyle,
                font: { ...(prevStyle.font || {}), bold: true },
                alignment: { ...(prevStyle.alignment || {}), horizontal: "center", vertical: "center" },
            };
        }

        // Percorre as linhas para aplicar formatação e cor
        listFinalToExport.forEach((item, index) => {
            let itemLista = listFinal[index];
            const excelRow = index + 2; // linha no Excel (1 = cabeçalho)

            for (let colIndex = 0; colIndex < totalCols; colIndex++) {
                const cellAddress = XLSXStyle.utils.encode_cell({ r: excelRow - 1, c: colIndex });
                if (worksheet[cellAddress]) {
                    // Aplica preenchimento cinza se !analitico
                    if (!itemLista.analitico) {
                        worksheet[cellAddress].s = {
                            fill: { fgColor: { rgb: "D3D3D3" } }
                        };
                    }

                    // Formatação moeda na coluna Valor
                    if (colIndex === valorColIndex) {
                        worksheet[cellAddress].z = '"R$"#,##0.00';
                    }
                }
            }
        });

        // Ajusta largura das colunas
        const colWidths = headers.map((header, colIndex) => {
            let maxLength = header.length;

            listFinalToExport.forEach(row => {
                let value = row[header];
                if (value != null) {
                    // Se for a coluna de valor, simula o formato "R$ 0,00"
                    if (colIndex === valorColIndex) {
                        value = `R$ ${parseFloat(value).toFixed(2)}`; 
                    }
                    const len = value.toString().length;
                    if (len > maxLength) maxLength = len;
                }
            });

            // Para a coluna de valor, garante largura mínima
            if (colIndex === valorColIndex && maxLength < 12) {
                maxLength = 12;
            }

            return { wch: maxLength + 2 };
        });

        worksheet['!cols'] = colWidths;

        const workbook = { Sheets: { [sheetName]: worksheet }, SheetNames: [sheetName] };
        const excelBuffer = XLSXStyle.write(workbook, { bookType: 'xlsx', type: 'array' });

        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(data, `${this.getFilenameToExport(true)}.xlsx`);
    }


    mapProdutosPorGrupo = (list) => {
        let mapProdutosPorGrupo = {}
        list.forEach(item => {
            const tipoEstoque = item.product.tipoEstoque.descricao
            let listProdutosTipoDeEstoque = mapProdutosPorGrupo[tipoEstoque]
            if(!listProdutosTipoDeEstoque){
                listProdutosTipoDeEstoque = []
            }
            listProdutosTipoDeEstoque.push(item)
            mapProdutosPorGrupo[tipoEstoque] = listProdutosTipoDeEstoque
        })
        
        //console.log("mapProdutosPorGrupo AAAAAAAAA: ", mapProdutosPorGrupo)
        return mapProdutosPorGrupo
    }

    montaMapGrupos = (list, separadorGruposEstoque) => {

        //console.log("bora: ", list)
        let mapGrupos = {}
        list.forEach(item => {
            let gruposListItem = item.product.tipoEstoque.descricao.split(separadorGruposEstoque)
            // //console.log("gruposList: ", gruposListItem)
            let sizeGruposItem = gruposListItem.length
            for(let i = 0; i < sizeGruposItem; i++){
                let listaGruposNivel_i = mapGrupos[i]
                if(!listaGruposNivel_i){
                    listaGruposNivel_i = []
                }

                let grupoIntermediario = gruposListItem[0]
                for(let j = 1; j <= i; j++){
                    grupoIntermediario = `${grupoIntermediario}${separadorGruposEstoque}${gruposListItem[j]}`
                }

                listaGruposNivel_i.push(grupoIntermediario)
                listaGruposNivel_i = [...new Set(listaGruposNivel_i)];
                mapGrupos[i] = listaGruposNivel_i
            }
        })

        //console.log("mapGrupos: ", mapGrupos)
        Object.entries(mapGrupos).forEach(([chave, valor]) => {
            // //console.log(chave, valor);
            let nivelGrupo = chave
            let listaGrupo = valor
            
            let listaGrupoObj = listaGrupo.map(grupo => {
                let obj = {
                    descricao: grupo,
                    valor: 0.0
                }
                return obj
            })

            mapGrupos[nivelGrupo] = listaGrupoObj

        });

        //console.log("mapGrupos obj: ", mapGrupos)
        return mapGrupos

    }

    preencheValoresGrupos = (list, separadorGruposEstoque, mapGrupos) => {

        list.forEach(item => {
            let gruposListItem = item.product.tipoEstoque.descricao.split(separadorGruposEstoque)
            let sizeGruposItem = gruposListItem.length
            let tipoEstoqueProduto = item.product.tipoEstoque.descricao
            for(let i = 0; i < sizeGruposItem; i++){
                //sizeGruposItem = 3; i = 0 => sizeGruposItem - i -1 = 2
                //sizeGruposItem = 3; i = 1 => sizeGruposItem - i -1 = 1
                //sizeGruposItem = 3; i = 2 => sizeGruposItem - i -1 = 0

                // //console.log(`item: ${item.product.descricao}, i: ${i}, tipoEstoqueProduto: ${tipoEstoqueProduto}`)

                let posicaoMap = sizeGruposItem - i -1
                let listGruposNivel_i = mapGrupos[posicaoMap]
                listGruposNivel_i.forEach(grupo => {
                    if(grupo.descricao === tipoEstoqueProduto){
                        grupo.valor += item.valor
                    }
                })

                //quebrar tipoEstoqueProduto
                const pos = tipoEstoqueProduto.lastIndexOf(" - ");
                tipoEstoqueProduto = pos === -1 ? tipoEstoqueProduto : tipoEstoqueProduto.substring(0, pos);

            }
        })

        //console.log("mapGrupos final com valor: ", mapGrupos)
        return mapGrupos

    }

    imprimeArvore = (itemPai, nivel, mapGrupos, separadorGruposEstoque, listFinal, mapProdutosPorGrupo) => {

        // //console.log("imprimeArvore: ", listFinal)

        let listNivel = mapGrupos[nivel]
        listNivel.forEach(item => {
            if(this.verificaItemFilho(item, itemPai, separadorGruposEstoque)){
                let obj = {
                    item: item.descricao,
                    valor: item.valor,
                    nivel: nivel,
                    analitico: false,
                }
                listFinal.push(obj)
                
                let listProdutosTipoDeEstoque = mapProdutosPorGrupo[item.descricao]
                if(listProdutosTipoDeEstoque){
                    // //console.log("ACHOU PROD EM IMPRIME ARVORE: ", listProdutosTipoDeEstoque)
                    let listaProdutos = listProdutosTipoDeEstoque.map(item => {
                        return {
                            item: item.product.descricao,
                            valor: item.valor,
                            nivel: nivel + 1,
                            analitico: true,
                        }
                    })
                    listFinal.push(...listaProdutos)
                }

                if(nivel < Object.keys(mapGrupos).length -1){
                    this.imprimeArvore(item, nivel + 1, mapGrupos, separadorGruposEstoque, listFinal, mapProdutosPorGrupo)
                }
            }
        })

        
        // let niveisList = Object.keys(mapGrupos).map(nivel => parseInt(nivel))
        // //console.log("niveisList: ", niveisList)

        // if(nivelItem === niveisList.length - 1){
        //     return;
        // }


    }

    verificaItemFilho = (item, itemPai, separadorGruposEstoque) => {
        
        if(!itemPai){
            return true
        }

        let prefixoItemPai = `${itemPai.descricao}${separadorGruposEstoque}`
        return item.descricao.startsWith(prefixoItemPai)

    }

    exportPDF = () => {
        this.exportarPdfButtonRef.current.show()
    }    

    exportPDFPorGrupos = () => {
        AuthService.startBlockUi()

        let columns = [
            { field: [colunaExportDescricaoLabel], header: colunaExportDescricaoLabel },
            { field: [colunaExportValorLabel], header: colunaExportValorLabel },
        ]
        
        let exportColumns = columns.map(col => ({ title: col.header, dataKey: col.field }))
        //console.log("exportColumns: ", exportColumns)

        const {listFinal, listFinalToExport} = this.getListFinalToExportPorGrupos()
        listFinalToExport.forEach(item => item[colunaExportValorLabel] = currencyFormater.format(item[colunaExportValorLabel], {locale: 'pt-BR', code: false}),)
        //console.log("exportList: ", listFinalToExport)
        this.createPDFFIle(this.getFilenameToExport(true), exportColumns, listFinalToExport, listFinal, true)

        AuthService.stopBlockUi()        
    }

    exportPDFPadrao = () => {

        AuthService.startBlockUi()

        let columns = [
            { field: [codigoLabel], header: "Código" },
            { field: [produtoLabel], header: "Produto" },
            ...(this.isBuscaNFsEntrada() ? [{ field: [fornecedorLabel], header: "Fornecedor" }] : []),
            { field: [ncmLabel], header: "NCM" },
            { field: [quantidadeLabel], header: "Quantidade" },
            { field: [valorTotalLabel], header: "Valor" },
            { field: [porcentagemLabel], header: porcentagemLabel },
            { field: [porcentagemAcumuladaLabel], header: porcentagemAcumuladaLabel },
        ]
        
        let exportColumns = columns.map(col => ({ title: col.header, dataKey: col.field }))

        let exportList = this.getListToExport(true)
        this.createPDFFIle(this.getFilenameToExport(), exportColumns, exportList, exportList, false)

        AuthService.stopBlockUi()

    }

    getColumnStyles = (isRelatorioPorGrupo) => {

        if(isRelatorioPorGrupo){
            return {
                0: { cellWidth: 130, halign: 'left' },
                1: { cellWidth: 30, halign: 'right' }, // Valor colado à direita
            }            
        }

        if(this.isBuscaNFsEntrada()){
            return {
                0: {cellWidth: 22.4},
                1: {cellWidth: 22.4},
                2: {cellWidth: 22.4},
                3: {cellWidth: 22.4},
                4: {cellWidth: 22.4},
                5: {cellWidth: 27.4},
                6: {cellWidth: 17.4},
                7: {cellWidth: 22.4},
            }
        }
        
        return {
                0: {cellWidth: 26.15},
                1: {cellWidth: 35.25},
                2: {cellWidth: 26.15},
                3: {cellWidth: 26.15},
                4: {cellWidth: 26.15},
                5: {cellWidth: 17.4},
                6: {cellWidth: 26.15},
        }
    }

    createPDFFIle = (filename, exportColumns, list, listComDados, isRelatorioPorGrupo) => {
        // var exportColumns = this.state.columns.map(col => ({ title: col.header, dataKey: col.field }))
        // var list = this.props.notFilteredList

        const filtradoPor = this.props.filtroTipoData === ConstantsUtil.filtroDataEmissaoLabel ? ConstantsUtil.filtroDataEmissaoLabelTratada : ConstantsUtil.filtroDataEntradaLabelTratada
        const filtroLabel = `Filtro: ${filtradoPor}`

        const periodoLabel = `Período: de ${this.props.initialDate.replaceAll("-", "/")} a ${this.props.finalDate.replaceAll("-", "/")}`
        
        const tipoLabel = `Tipo: ${this.props.tipo}`

        const empresasLabel = `Empresa: ${AuthService.getEmpresa()}`

        import('jspdf').then(jsPDF => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);

                // Adicionar título
                doc.setFontSize(20);
                let porGrupoLabel = isRelatorioPorGrupo ? ' Por Grupo' : ''
                const titulo = `Relatório de ${this.isBuscaNFsEntrada() ? 'Compras' : 'Vendas'} Por Produto${porGrupoLabel} - Bepp`;
                const tituloWidth = doc.getTextWidth(titulo);
                const tituloX = (doc.internal.pageSize.width - tituloWidth) / 2;
                doc.text(titulo, tituloX, 15);                

                // Adicionar linhas de texto
                doc.setFontSize(12);
                doc.text(filtroLabel, 10, 25);
                doc.text(periodoLabel, 10, 30);
                doc.text(tipoLabel, 10, 35);
                doc.text(empresasLabel, 10, 40);
                // doc.text('Data: ' + new Date().toLocaleDateString(), 10, 15);
                // doc.text('Total de registros: ' + list.length, 10, 20);                
                
                doc.autoTable({
                    startY: 50,
                    head: [exportColumns.map(col => col.title)],
                    body: list.map(item => exportColumns.map(col => item[col.dataKey])),
                    columnStyles: this.getColumnStyles(isRelatorioPorGrupo),
                    styles: {
                        fontSize: 8
                    },
                    didParseCell: (data) => {
                        if (data.section === 'body' && isRelatorioPorGrupo) {  // só linhas do corpo da tabela
                            const rowIndex = data.row.index;
                            const item = listComDados[rowIndex];
                            if (!item.analitico) {
                                data.cell.styles.fillColor = '#D3D3D3';
                            }
                            // else{
                            //     data.cell.styles.fillColor = '#ffffff';
                            // }
                        }
                    }
                });

                doc.save(filename);
            })
        })
    }

    viewDetalhamentoQuantidade = async (rowData) => {
        // //console.log("viewDetalhamentoQuantidade: ", rowData)
        this.setState({displayDetalhamentoDialog: true})
        this.setState({productDetalhamento: rowData.product})
    }

    hideDetalhamentoDialog = () => {
        this.setState({displayDetalhamentoDialog: false})
        this.setState({productDetalhamento: null})
    }

    isBuscaNFsEntrada = () => {
        return this.props.tipo === ConstantsUtil.tipoNFEntradaLabel
    }

    estaFiltrando = () => {
        let estaFiltrando = this.state.filteredList && this.state.filteredList.length !== this.props.list.length
        return estaFiltrando
    }

    getValorTotalHeader = () => {
        /*
        Inicialmente, o valor total na visualização por produto era a soma do valor total de cada produto.
        No entanto, essa soma não representava de fato o valor gasto/recebido. Já o valor das NFs sim.
        
        Por exemplo, quando há devolução de NFs de entrada, na visualização por nota, a NF de devolução é somada com
        valor negativo, deduzindo o pagamento.
        Porém, na visualização por produto não conseguimos deduzir esse valor por não saber qual produto exato da NF foi
        devolvido para subtrair apenas o valor dele.

        Dessa forma, apresenta o valor total recebido pela prop, que é o valor total das NFs.

        No entanto, se o usuário estiver realizando filtro, então calcula pela soma dos valores dos produtos filtrados.
        */
        if(!this.estaFiltrando() && this.props.valorTotal){
            return this.props.valorTotal
        }
        return this.getValorTotal()
    }

    getExportarOptions = (isExcel) => {
        return [
            {
                label: 'Padrão',
                // icon: 'pi pi-refresh',
                command: () => {
                    isExcel ? this.exportXLSXPadrao() : this.exportPDFPadrao()
                }
            },
            {
                label: 'Por Grupos',
                // icon: 'pi pi-times',
                command: () => {
                    isExcel ? this.exportXLSXPorGrupos() : this.exportPDFPorGrupos()
                }
            },
            {
                label: 'Lançamentos Individuais (esta empresa)',
                command: () => {
                    isExcel ? this.abrirEscolhaSituacaoNotasIndividuais(false) : this.exportPDFIndividuais()
                }
            },
            {
                label: 'Lançamentos Individuais (unificado)',
                command: () => {
                    isExcel ? this.abrirEscolhaSituacaoNotasIndividuais(true) : this.exportPDFIndividuais()
                }
            },
        ]
    }

    render() {

        //codigoFilterElement Filter
        const codigoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedCodigo,
            this.props.list,
            "selectedCodigo",
            (name, value) => this.setState({[name]: value}),
            'product.codigo',
            '100%',
            "Código"
        )

        //descricaoFilterElement Filter
        const descricaoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedDescricao,
            this.props.list,
            "selectedDescricao",
            (name, value) => this.setState({[name]: value}),
            'product.descricao',
            '100%',
            "Descrição"
        )

        //nomeFornecedorFilterElement Filter
        const nomeFornecedorFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedNomeFornecedor,
            this.props.list,
            "selectedNomeFornecedor",
            (name, value) => this.setState({[name]: value}),
            'product.nomeFornecedor',
            '100%',
            "Fornecedor"
        )

        //tipoProdutoFilterElement
        const tipoProdutoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedTipoProduto,
            this.props.list,
            "selectedTipoProduto",
            (name, value) => this.setState({[name]: value}),
            'product.tipoProduto.descricao',
            '100%',
            "Tipo De Produto"
        )

        const classificacaoDREFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedClassificacaoDRE,
            this.props.list,
            "selectedClassificacaoDRE",
            (name, value) => this.setState({[name]: value}),
            'product.tipoProduto.tipoDreCompetencia.descricao',
            '100%',
            "Classificação DRE"
        )

        //tipoEstoqueFilterElement
        const tipoEstoqueFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedTipoEstoque,
            this.props.list,
            "selectedTipoEstoque",
            (name, value) => this.setState({[name]: value}),
            'product.tipoEstoque.descricao',
            '100%',
            "Tipo De Estoque"
        )

        //ncmFilterElement Filter
        const ncmFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedNcm,
            this.props.list,
            "selectedNcm",
            (name, value) => this.setState({[name]: value}),
            'product.ncm',
            '100%',
            "NCM"
        )

        const cfopFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedCfop,
            this.props.list,
            "selectedCfop",
            (name, value) => this.setState({[name]: value}),
            'product.cfop',
            '100%',
            "CFOP"
        )

        //quantidadeFilterElement Filter
        const quantidadeFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedQuantidade,
            this.props.list,
            "selectedQuantidade",
            (name, value) => this.setState({[name]: value}),
            'quantidade',
            '100%',
            "Quantidade"
        )

        //valorFilterElement Filter
        const valorFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedValor,
            this.props.list,
            "selectedValor",
            (name, value) => this.setState({[name]: value}),
            'valor',
            '100%',
            "Valor"
        )

        const exportHeader = () => {
            return (
                <React.Fragment>
                    
                    <SplitButton
                        ref={this.exportarExcelButtonRef}
                        label="Exportar"
                        icon="pi pi-file-excel"
                        className="p-button-success small-font small-button"
                        model={this.getExportarOptions(true)}
                        onClick={this.exportXLSX}
                        tooltip={ConstantsUtil.exportXlsxLabel}
                        tooltipOptions={{position: 'top'}}
                    />

                    <SplitButton
                        ref={this.exportarPdfButtonRef}
                        label="Exportar"
                        icon="pi pi-file-pdf"
                        className="p-button-danger small-font small-button"
                        model={this.getExportarOptions(false)}
                        onClick={this.exportPDF}
                        style={{marginLeft: '10px'}}
                        tooltip={ConstantsUtil.exportPdfLabel}
                        tooltipOptions={{position: 'top'}}
                    />
                </React.Fragment>
            )
        }

        const renderValorMedio = () => {
            if(this.estaFiltrando()){
                return (
                    <div className='col-md-3'>
                        <Button
                            label={`Valor Médio: R$ ${GeneralServices.valueBodyTemplate(this.getValorTotal()/this.getQuantidadeTotal())}`}
                            className=" small-font small-button p-button-success"
                        />
                    </div>
                )
            }
        }

        const totaisHeader = () => {
            return (
                <>
                    <div className='col-md-3'>
                        <Button
                            // label={`Total: R$ ${GeneralServices.valueBodyTemplate(this.getValorTotal())}`}
                            label={`Valor Total: R$ ${GeneralServices.valueBodyTemplate(this.getValorTotalHeader())}`}
                            className=" small-font small-button"
                        />
                    </div>

                    <div className='col-md-3'>
                        <Button
                            label={`Quantidade: ${GeneralServices.valueBodyTemplate(this.getQuantidadeTotal())} Itens`}
                            className=" small-font small-button p-button-help"
                        />
                    </div>

                    {renderValorMedio()}

                </>
            )
        }

        const renderViewQuantidadeLink = (rowData) => {
            let quantidade = rowData.quantidade
            const cond1 = quantidade && quantidade !== 0
            if( cond1 ){
                const classes = classNames({
                    'deficitValue': quantidade < 0,
                    'linkValue': true
                    
                });
                return(
                    <a 
                        className={classes}
                        onClick={() => this.viewDetalhamentoQuantidade(rowData)}
                    >
                        {quantidade}
                    </a>
                )
            }
            else{
                return(
                    <>
                        {GeneralServices.showFormattedIfNonZero(quantidade, false)}
                    </>
                )
            }
        }        

        const renderDetalhamentoDialog = () => {
            if(this.state.displayDetalhamentoDialog)
                return (
                    <DetalhamentoMovimentacaoProductDialog
                        visible={this.state.displayDetalhamentoDialog}
                        tipo={this.props.tipo}
                        product={this.state.productDetalhamento}
                        dataInicial={this.props.initialDate}
                        dataFinal={this.props.finalDate}
                        fromFichaDeEstoque={false}
                        tipoProdutoDetalhamento={this.props.tipoProdutoDetalhamento}
                        filtroTipoData={this.props.filtroTipoData}
                        // tipoAtualizacaoFichaDeEstoque={this.state.fichaDeEstoqueDetalhamento.tipoAtualizacao}
                        // unificar={this.props.unificar}
                        hideDialog={this.hideDetalhamentoDialog}
                    />
                )
        }

        const renderFornecedorColumn = () => {
            if(this.isBuscaNFsEntrada()){
                return (
                    <Column
                        field="product.nomeFornecedor"
                        header="Fornecedor"
                        style={ {width: '140px'} }
                        sortable
                        filter filterElement={nomeFornecedorFilterElement}
                    />

                )
            }
        }


        return (
            <div
                className=""
            >
            <div className="card visaorj-small">
                
                <div className='card-header'>
                    <div className='row'>
                        <div className='col-md-3'>
                            {exportHeader()}
                        </div>
                            {totaisHeader()}
                    </div>
                </div>
                
                <DataTable
                    ref={this.dt}
                    value={this.props.list}
                    className="p-datatable-sm small-font"
                    rowHover
                    onValueChange={this.onFilterChange}
                    // showGridlines
                    scrollable
                    scrollHeight="500px"
                    loading={this.props.loading}
                    emptyMessage={ConstantsUtil.nenhumLancamentoEncontradoMessage}
                    dataKey="product.id"
                    paginator rows={ConstantsUtil.initialTableQuantityOption}
                    paginatorTemplate={GeneralServices.tablePaginatorTemplate(ConstantsUtil.initialTableQuantityOption, this.props.list ? this.props.list.length : '')}
                    currentPageReportTemplate="Mostrando de {first} ao {last} de {totalRecords} Lançamentos"
                >

                    <Column
                        header="Código"
                        field="product.codigo"
                        style ={ {width: '30px'} }
                        sortable
                        filter filterElement={codigoFilterElement}
                        body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.product.codigo, rowIndex)}
                    />

                    <Column
                        field="product.descricao"
                        header="Produto"
                        style={ {width: '140px'} }
                        sortable
                        filter filterElement={descricaoFilterElement}
                    />

                    {renderFornecedorColumn()}

                    <Column
                        header="Tipo de Produto"
                        style ={ {width: '80px'} }
                        field="product.tipoProduto.descricao"
                        filter filterElement={tipoProdutoFilterElement}
                    />

                    <Column
                        header={ConstantsUtil.classificacaoDRELabel}
                        style ={ {width: '80px'} }
                        field="product.tipoProduto.tipoDreCompetencia.descricao"
                        filter filterElement={classificacaoDREFilterElement}
                    />

                    <Column
                        header="Tipo de Estoque"
                        style ={ {width: '80px'} }
                        field="product.tipoEstoque.descricao"
                        filter filterElement={tipoEstoqueFilterElement}
                    />

                    <Column
                        header="NCM"
                        style ={ {width: '30px'} }
                        field="product.ncm"
                        filter filterElement={ncmFilterElement}
                    />

                    <Column
                        header="CFOP"
                        style ={ {width: '30px'} }
                        field="product.cfop"
                        filter filterElement={cfopFilterElement}
                    />

                    <Column
                        header="Quantidade"
                        field="quantidade"
                        style ={ {width: '80px'} }
                        sortable
                        filter filterElement={quantidadeFilterElement}
                        body={rowData => {
                            return renderViewQuantidadeLink(rowData)
                        }}
                        
                    />

                    <Column
                        header="Valor"
                        field = "valor"
                        style ={ {width: '80px'} }
                        sortable
                        body={rowData => GeneralServices.valueBodyTemplate(rowData.valor)}
                        filter filterElement={valorFilterElement}
                    />

                    <Column
                        header={porcentagemLabel}
                        style ={ {width: '40px'} }
                        body={rowData => this.formataPorcentagem(rowData.porcentagem) }
                    />

                    <Column
                        header={porcentagemAcumuladaLabel}
                        style ={ {width: '40px'} }
                        body={rowData => this.formataPorcentagem(rowData.porcentagemAcumulada) }
                    />

                </DataTable>

                {renderDetalhamentoDialog()}

                <EscolhaSituacaoNotasDialog
                    visible={this.state.displayEscolhaSituacaoNotasDialog}
                    onEscolher={this.onEscolherSituacaoNotasIndividuais}
                    hideDialog={this.hideEscolhaSituacaoNotasDialog}
                />

            </div>

        </div>
        )
    }


}  

export default TransactionByProductTable